// Compact bout top bar for phones (<=900 px wide or <=500 px high). Spec: docs/design/ui/2026-10-11-bout-hud-phone.md.
// CSS only: overrides the .duel-top layout of duelHud.ts (same DOM), so the rage bars of DUEL-V3-P2 stay (thin lines).
// Desktop is untouched. Specificity (.duel-ui prefix) beats the runtime <style> of duelHud.ts whatever the order.
const Q = '@media (max-width:900px),(max-height:500px)';
const CSS = `${Q}{
.duel-ui .duel-top{top:max(6px,env(safe-area-inset-top));width:calc(100vw - 12px);max-width:none;grid-template-columns:minmax(0,266px) 172px minmax(0,266px);justify-content:space-between;gap:8px;height:34px;align-items:stretch}
.duel-ui .duel-side{position:relative;padding:2px 6px 3px;border-radius:8px;background:rgba(20,18,16,.6);overflow:hidden;min-width:0}
.duel-ui .duel-side b{font-size:10px;line-height:12px;display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.duel-ui .duel-side small{display:none}
.duel-ui .duel-bar{height:8px;margin-top:1px;border-width:1px}
.duel-ui .duel-gp{height:2px;margin-top:2px;border:0}
.duel-ui .duel-gp b{display:none}
.duel-ui .duel-stam{height:2px;margin-top:2px}
.duel-ui .duel-rage{height:3px;margin-top:2px;border:0}
.duel-ui .duel-mid{display:flex;align-items:center;justify-content:center;gap:8px;padding:0 6px;background:rgba(20,18,16,.6)}
.duel-ui .duel-mid .clock{font-size:18px;line-height:20px}
.duel-ui .duel-mid .round{display:none}
.duel-ui .duel-mid .duel-pips{margin:0;gap:3px;order:-1}
.duel-ui .duel-pips span{width:6px;height:6px}
.duel-ui .duel-foe .duel-pips{position:absolute;left:6px;top:2px;margin:0}
.duel-ui .duel-quit{top:max(50px,calc(env(safe-area-inset-top) + 44px));right:6px;font-size:10px;padding:2px 8px;opacity:.8}
.duel-ui .duel-tell{top:52px}
.duel-ui .duel-out{top:46px}.duel-ui .duel-out .me{font-size:15px;padding:2px 10px}.duel-ui .duel-out .foe{font-size:12px;padding:2px 8px}
body.tourney-bout .duel-top{top:max(6px,env(safe-area-inset-top))!important}
body.tourney-bout .duel-tell{top:52px!important}
.tourney-ribbon{top:44px;animation:duelRibbonOut .4s ease 2.5s forwards}
}
@keyframes duelRibbonOut{to{opacity:0}}`;
const style = document.createElement('style');
style.textContent = CSS;
document.head.append(style);
export {};
